module.exports = __webpack_public_path__ + "static/media/IMG_3510_sm.44ab7ce6.jpg";